import { CheckoutSection } from '@/common.styled';
import styled from 'styled-components';

export const Section = styled(CheckoutSection)`
  align-items: center;

  & h2 {
    font-size: var(--font-size-text-md);
    font-weight: var(--font-weight-regular);
    line-height: 24px;
    color: var(--grey-800);
    text-align: center;
  }
`;

export const Text = styled.p`
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-regular);
  line-height: 24px;
  color: var(--grey-500);
  text-align: center;
  margin: 0;
`;
